import { render, staticRenderFns } from "./scoreTable.vue?vue&type=template&id=359e8ce3&scoped=true&"
import script from "./scoreTable.vue?vue&type=script&lang=js&"
export * from "./scoreTable.vue?vue&type=script&lang=js&"
import style0 from "./scoreTable.vue?vue&type=style&index=0&id=359e8ce3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359e8ce3",
  null
  
)

export default component.exports